<!--
  Component: MetricThenNow

  This component creates a two-column table of labels + school / comp values.

  Notes:
  - Two column headings
  - Should be paired so part after the prefixes match between row labels and
    school/comp values
  - Loops through list of labels (in metadata order, not re-sorted) to search
    for suffixes to match on
-->
<template>
  <div class="metric-then-now">
    <h5 class="title" v-if="hasTitle">{{titleValue}}</h5>
    <table>
      <tr>
        <th v-if="col1Heading" class="column-1">{{col1Heading}}</th>
        <td v-else class="column-1 empty-header"></td>

        <th v-if="col2Heading" class="column-2">{{col2Heading}}</th>
        <td v-else class="column-2 empty-header"></td>
      </tr>
      <tr v-for="d in rowSlotData" :key="d.component_slot">
        <td class="column-1">{{labelForRowSlot(d)}}</td>
        <td class="column-2">
          <div>{{schoolValueForRowSlot(d)}} {{schoolTextForRowSlot(d)}}</div>
          <div class="comp" v-if="hasCompForRowSlot(d)">(Comp Group: {{compValueForRowSlot(d)}})</div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Component from 'vue-class-component'

import MetadataBase from './MetadataBase'

/* Valid Slot Names for this Component */
/* Prefixes (followed by any string) for Valid Slot Names for this Component */
const SN_COL_1 = 'col_heading_1'
const SN_COL_2 = 'col_heading_2'
const SN_ROW_PREFIX = 'row_label_'
const SN_SCHOOL_PREFIX = 'school_value_'
const SN_COMP_PREFIX = 'comp_value_'

@Component({
})
export default class MetricThenNow extends MetadataBase {
  /* Getters */

  get hasTitle () { return this.hasSlotName('') }
  get titleValue () { return this.mainDisplayText }
  get col1Heading () { return this.displayTextForSlotName(SN_COL_1) }
  get col2Heading () { return this.displayTextForSlotName(SN_COL_2) }

  get rowSlotData () { return this.slotDataForPrefix(SN_ROW_PREFIX) }
  get schoolSlotData () { return this.slotDataForPrefix(SN_SCHOOL_PREFIX) }
  get compSlotData () { return this.slotDataForPrefix(SN_COMP_PREFIX) }

  /* Methods - utility */

  labelForRowSlot (slotData) {
    return this.displayTextForSlotName(slotData.component_slot)
  }

  slotNameForLabelSlot (slotData, newPrefix) {
    return slotData.component_slot.replace(SN_ROW_PREFIX, newPrefix)
  }
  schoolSlotNameForLabelSlot (slotData) {
    return this.slotNameForLabelSlot(slotData, SN_SCHOOL_PREFIX)
  }
  compSlotNameForLabelSlot (slotData) {
    return this.slotNameForLabelSlot(slotData, SN_COMP_PREFIX)
  }

  schoolValueForRowSlot (slotData) {
    const slotName = this.schoolSlotNameForLabelSlot(slotData)
    return this.dispValueForSlotName(slotName)
  }
  schoolTextForRowSlot (slotData) {
    const slotName = this.schoolSlotNameForLabelSlot(slotData)
    return this.displayTextForSlotName(slotName)
  }

  hasCompForRowSlot (slotData) {
    const slotName = this.compSlotNameForLabelSlot(slotData)
    return this.hasSlotName(slotName)
  }
  compValueForRowSlot (slotData) {
    const slotName = this.compSlotNameForLabelSlot(slotData)
    return this.dispValueForSlotName(slotName)
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../css/const.scss';
$table-margin: 18px;
.metric-then-now {
  margin-top: 1.2em;
  .title {
    margin-top: 0;
    margin-bottom: 1em;
  }
}

table {
  margin: 0px $table-margin;
  width: calc(100% - 2*#{$table-margin});
  border-collapse: collapse;
  max-width: 400px;
  th, td {
    vertical-align: top;
  }
  td > div {
    display: inline-block;
  }
}

th, td {
  border: 0px solid black;
}
th, td.empty-header {
  border-bottom-width: 1px;
}

.comp {
  color: #555555;
}
.column-1 {
  width: 91px;
  border-right-width: 1px;
}
.column-2 {
  padding-left: 16px;
}

/* Responsive rules */

@media screen and (max-width: $screen-width-2-column-large) {
table {
  margin: 0px;
  width: 100%;
  td > div {
    display: block;
  }
}
}
@media screen and (max-width: $screen-width-1-column-large) {
table {
  margin: 0px $table-margin;
  width: calc(100% - 2*#{$table-margin});
  td > div {
    display: inline-block;
  }
}
}
@media screen and (max-width: $screen-width-1-column-small) {
table {
  margin: 0px;
  width: 100%;
  td > div {
    display: block;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2017/tab-mods/MetricThenNow.vue